import { format as formatDate, startOfDay } from 'date-fns';
import { InputHTMLAttributes, forwardRef } from 'react';

export const TextField = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(({ type = 'text', className = '', ...props }, ref) => {
  let format = '';
  let formatDates = false;
  if (type === 'date') {
    format = 'yyyy-MM-dd';
    formatDates = true;
  } else if (type === 'datetime') {
    type = 'datetime-local';
    format = "yyyy-MM-dd'T'HH:mm";
    formatDates = true;
  }

  if (formatDates && props.max === 'today') {
    props.max = formatDate(startOfDay(new Date()), format);
  }

  if (formatDates && props.min === 'today') {
    props.min = formatDate(startOfDay(new Date()), format);
  }

  if (formatDates && props.max === 'now') {
    props.max = formatDate(new Date(), format);
  }

  if (formatDates && props.min === 'now') {
    props.min = formatDate(new Date(), format);
  }

  if (formatDates && !props.max) {
    props.max = '9999-12-31';
  }

  //Purposely made input compared to field because I am using the same component for the search
  return <input type={type} ref={ref} className="tribute-text-field tribute-text-input" {...props} />;
});
